module.exports = {
  PIX_KEY: 'pix_key',
  PIX_QR_CODE_STATIC: 'pix_qr_code_static',
  PIX_QR_CODE_DYNAMIC: 'pix_qr_code_dynamic',
  CHARGE_BOLETO: 'charge_boleto',
  CHARGE_BOLETO_QR_CODE: 'charge_boleto_qr_code',
  CHARGE_PIX_QR_CODE_DYNAMIC: 'charge_pix_qr_code_dynamic',
  MANUAL: 'manual'
};
